import type { SpinopelvicInputs, SpinopelvicState } from '@/spinopelvic/store/types';
import { makeDataState } from '@/util/dataState';
import { cloneDeep } from 'lodash';

export const initialInputs: SpinopelvicInputs = {
    standingPelvicTilt: '',
    pelvicFemoralAngle: '',
    lumbarLordosis: '',
    sacralSlope: '',
    pelvicTilt: '',
};

export const initialState: SpinopelvicState = {
    ...makeDataState(),
    current: cloneDeep(initialInputs),
    lastSaved: cloneDeep(initialInputs),
};
